function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14C11.3135 14 14 11.3144 14 8C14 4.68749 11.3135 2 8 2C4.68652 2 2 4.68749 2 8C2 11.3144 4.68652 14 8 14ZM8 6.69355C7.4388 6.69355 6.98387 6.23862 6.98387 5.67742C6.98387 5.11622 7.4388 4.66129 8 4.66129C8.5612 4.66129 9.01613 5.11622 9.01613 5.67742C9.01613 6.23862 8.5612 6.69355 8 6.69355ZM9.06452 11.0968H6.93548C6.77515 11.0968 6.64516 10.9668 6.64516 10.8065V10.2258C6.64516 10.0655 6.77515 9.93548 6.93548 9.93548H7.22581V8.3871H6.93548C6.77515 8.3871 6.64516 8.2571 6.64516 8.09677V7.51613C6.64516 7.3558 6.77515 7.22581 6.93548 7.22581H8.48387C8.6442 7.22581 8.77419 7.3558 8.77419 7.51613V9.93548H9.06452C9.22485 9.93548 9.35484 10.0655 9.35484 10.2258V10.8065C9.35484 10.9668 9.22485 11.0968 9.06452 11.0968Z",
  fill: "#637381"
});

var SvgInfoIcon = function SvgInfoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-icon.37c6e8e3.svg";
export { ForwardRef as ReactComponent };